import React from 'react';
import { useUploadQueue } from '../../hooks/useUploadQueue';

/**
 * Headless component that mounts the upload queue processor.
 * The tray UI is rendered inline in TopAppBar via UploadIndicator.
 */
export const UploadTray: React.FC = () => {
  useUploadQueue();
  return null;
};
